import InstructorPicker from "./InstructorPicker";
export default InstructorPicker;
